import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function HomeIcon({ className, width = 23, height = 23 }: IconProps) {
    return (
        <svg
            className={cn('fill-current', className)}
            width={width}
            height={height}
            viewBox='0 0 23 23'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M17.29 22.25H15.5C14.3954 22.25 13.5 21.3545 13.5 20.25V17C13.5 16.4477 13.0523 16 12.5 16H10.5C9.94771 16 9.5 16.4477 9.5 17V20.25C9.5 21.3545 8.60457 22.25 7.5 22.25H5.71C2.97 22.25 0.75 20.02 0.75 17.28V9.86997C0.75 8.50997 1.59 6.79997 2.67 5.95997L8.06 1.75997C9.68 0.499974 12.27 0.439974 13.95 1.61997L20.13 5.94997C21.32 6.77997 22.25 8.55997 22.25 10.01V17.29C22.25 20.02 20.03 22.25 17.29 22.25ZM8.98 2.93997L3.59 7.13997C2.88 7.69997 2.25 8.96997 2.25 9.86997V17.28C2.25 19.19 3.8 20.75 5.71 20.75H6.98C7.53228 20.75 7.98 20.3023 7.98 19.75V16.5C7.98 15.3954 8.87543 14.5 9.98 14.5H13C14.1046 14.5 15 15.3954 15 16.5V19.75C15 20.3023 15.4477 20.75 16 20.75H17.29C19.2 20.75 20.75 19.2 20.75 17.29V10.01C20.75 9.04997 20.06 7.71997 19.27 7.17997L13.09 2.84997C11.95 2.04997 10.07 2.08997 8.98 2.93997Z' />
        </svg>
    );
}

export default HomeIcon;

